/* eslint-disable react/sort-comp */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';

import { getBranchesOptions } from '../../../../app/store/actions/branches';
import { getAllQRCodes } from '../../../../app/store/actions/QRCodeConfig';
import { getUserList } from '../../../../app/store/actions/ranges';

import { getCustomersOptions } from '../../../../app/store/actions/customers';
import { createTypeOrder, getGridOptions, updateTypeOrders } from '../../../../app/store/actions/typeOrder';
import OneClickButton from '../../../../components/form/button';
import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';
import DualList from '../../../../components/pages/DualList';
import {
  Panel,
  PanelBody, PanelFooter,
  PanelHeader,
} from '../../../../components/panel/panel';
import ROUTES from '../../../../config/routes';

class TypeOrdersForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typeOrderId: '',
      activeTab: '1',
      mode: 'detail',
      showCreate: false,
      showUpdate: false,
      showCancel: false,
      type: '',
      name: '',
      prefix: '',
      disablePrefix: true,
      disableName: true,
      disableType: true,
      disableBranchCode: true,
      branchName: '',
      branchCode: '',
      branchPickingByLoad: false,
      listBranch: [],
      requestWeightDimensions: false,
      mandatoryWeightDimensions: false,
      preConference: false,
      receiveLeftover: false,
      partialInboundCheck: false,
      inboundCheckPlate: false,
      automaticStorage: false,
      disableAutomaticStorage: true,
      disableRequestProduct: true,
      disableMandatoryProduct: true,
      disablePreConference: true,
      disableReceiveLeftover: true,
      disablePartialInboundCheck: true,
      disableInboundCheckPlate: true,
      usesCableCuttingPlan: false,
      consolidation: false,
      dockControl: false,
      validateDockRemoval: false,
      automaticPickingConfirmation: false,
      blindConference: false,
      automaticSeparationAfterCuttingCables: false,
      restrictionPicking: false,
      automaticCheckAfterPicking: false,
      automaticPrintAfterPicking: false,
      disableConsolidation: true,
      disableDockControl: true,
      disableValidateDockRemoval: true,
      disableBlindConference: true,
      disableAutomaticSeparationAfterCuttingCables: true,
      disabledRestrictionPicking: true,
      disableAutomaticCheckAfterPicking: true,
      disableAutomaticPrintAfterPicking: true,
      usesIndustryProcess: false,
      disabledUsesIndustryProcess: true,
      productionSeparation: false,
      disabledProductionSeparation: true,
      awaitBilling: false,
      disabledAwaitBilling: true,
      automaticAllocation: false,
      disabledAutomaticAllocation: true,
      usesRequestManual: false,
      disableAutomaticPickingConfirmation: true,
      disabledUsesRequestManual: true,
      selectedInboundDeposits: [],
      selectedAllocateBalanceDeposits: [],
      urgentAutoAssignSeparator: false,
      disableUrgentAutoAssignSeparator: true,
      fullAllocation: false,
      disableFullAllocation: true,
      documentSeparationUzSuggestion: false,
      disableDocumentSeparationUzSuggestion: true,
      separateProductIntegration: false,
      disableSeparateProductIntegration: true,
      itemLevelObservation: false,
      disableItemLevelObservation: true,
      orderLevelObservation: false,
      disableOrderLevelObservation: true,
      automaticDistributeOrders: false,
      disableAutomaticDistributeOrders: true,
      preStorageStage: false,
      disablePreStorageStage: true,
      separationStage: false,
      disableSeparationStage: true,
      simplifiedLoadPicking: false,
      loadConsolidation: false,
      disableSimplifiedLoadPicking: true,
      groupedOutboundCustomerCode: '',
      groupedOutboundCustomerName: '',
      listGroupedOutboundCustomers: [],
      disableGroupedOutboundCustomer: true,
      singleScanReturnAddress: false,
      customerReturn: false,
      disableCustomerReturn: true,
      disableSingleScanReturnAddress: true,
      requestDeliveryConfirmation: false,
      disableRequestDeliveryConfirmation: true,
      groupProductsOnSeparation: false,
      printOutboundFractionalPackagingLabel: false,
      printInboundFractionalPackagingLabel: false,
      printFractionalLabelAfterLotConference: false,
      hideQuantityOnLabelWithoutCuttingPlan: false,
      disableGroupProductsOnSeparation: true,
      optionsColumnOrderSeparation: [],
      selectedColumnOrderSeparation: [],
      inboundManualRequest: false,
      disableManualRequestInbound: true,
      disablePrintOutboundFractionalPackagingLabel: true,
      disablePrintInboundFractionalPackagingLabel: true,
      printSalesOrderPdf: false,
      disablePrintSalesOrderPdf: true,
      manualConfirmPicking: false,
      disableManualConfirmPicking: true,
      selectedInboundColumnOrderCheck: [],
      optionsInboundColumnOrderCheck: [],
      selectedInboundColumnOrderStorage: [],
      selectedOutboundColumnOrderCheck: [],
      usesQrCode: false,
      disableUsesQrCode: true,
      listQRCodes: [],
      qrCodeModelCode: '',
      qrCodeModelName: '',
      automaticCableCuttingPlan: false,
      disableAutomaticCableCuttingPlan: true,
      defaultSeparatorCode: '',
      defaultSeparatorName: '',
      listDefaultSeparators: [],
      defaultInboundDepositCode: '',
      defaultInboundDepositName: '',
      disableDefaultInboundDeposit: true,
      disableDefaultSeparator: true,
      manualWaybill: false,
      disableManualWaybill: true,
      listUsersRestriction: [],
      selectedUsersRestrictionInbound: [],
      selectedUsersRestrictionOutbound: [],
      advanceBilling: false,
      disableAdvanceBilling: true,
    };
  }

  async componentDidMount() {
    await this.getOptions();
    await this.setMode();
    if (this.state.mode !== 'create') {
      await this.getOrderTypeSelected(false);
    }
  }

  onChangeDualList = (selected, field) => {
    if (field === 'selectedInboundDeposits') {
      const { defaultInboundDepositCode } = this.state;
      const isSelected = selected.includes(defaultInboundDepositCode);
      this.setState({
        selectedInboundDeposits: selected,
        ...(!isSelected && {
          defaultInboundDepositCode: '',
          defaultInboundDepositName: '',
        }),
      });
      return;
    }

    this.setState({ [field]: selected });
  };

  getOptions = async () => {
    const { groupProductsOnSeparation } = this.state;
    let orderSelectedId = '';

    if (this.props.location.state && this.props.location.state.orderType) {
      const { orderType } = this.props.location.state;
      const orderSelected = await orderType;

      if (orderSelected) orderSelectedId = orderSelected.id;
    }

    const listBranch = await this.props.getBranchesOptions();

    const {
      inboundDeposits, allocateBalanceDeposits, columnOrderSeparation, inboundColumnOrderCheck,
      inboundColumnOrderStorage, outboundColumnOrderCheck,
    } = await this.props.getGridOptions({ orderSelectedId, groupProductsOnSeparation });
    const { mainBranch, mainBranchData } = await this.props.userLogged;
    const selectBranch = listBranch.find((element) => element.value === mainBranch);

    if (selectBranch) {
      this.setState({
        branchCode: selectBranch.value,
        branchName: selectBranch.label,
        branchPickingByLoad: selectBranch.pickingByLoad,
        usesCableCuttingPlan: mainBranchData.usesCableCuttingPlan,
      });
    }

    this.setState({
      listBranch,
      optionsInboundDeposits: inboundDeposits && inboundDeposits.options
        ? inboundDeposits.options : [],
      optionsAllocateBalanceDeposits: allocateBalanceDeposits && allocateBalanceDeposits.options
        ? allocateBalanceDeposits.options : [],
      selectedInboundDeposits: inboundDeposits && inboundDeposits.selected ? inboundDeposits.selected : [],
      selectedAllocateBalanceDeposits: allocateBalanceDeposits && allocateBalanceDeposits.selected
        ? allocateBalanceDeposits.selected : [],
      optionsColumnOrderSeparation: columnOrderSeparation && columnOrderSeparation.options
        ? columnOrderSeparation.options : [],
      selectedColumnOrderSeparation: columnOrderSeparation && columnOrderSeparation.selected
        ? columnOrderSeparation.selected : [],
      optionsInboundColumnOrderCheck: inboundColumnOrderCheck && inboundColumnOrderCheck.options
        ? inboundColumnOrderCheck.options : [],
      selectedInboundColumnOrderCheck: inboundColumnOrderCheck && inboundColumnOrderCheck.selected
        ? inboundColumnOrderCheck.selected : [],
      optionsInboundColumnOrderStorage: inboundColumnOrderStorage && inboundColumnOrderStorage.options
        ? inboundColumnOrderStorage.options : [],
      selectedInboundColumnOrderStorage: inboundColumnOrderStorage && inboundColumnOrderStorage.selected
        ? inboundColumnOrderStorage.selected : [],
      optionsOutboundColumnOrderCheck: outboundColumnOrderCheck && outboundColumnOrderCheck.options
        ? outboundColumnOrderCheck.options : [],
      selectedOutboundColumnOrderCheck: outboundColumnOrderCheck && outboundColumnOrderCheck.selected
        ? outboundColumnOrderCheck.selected : [],
    });

    const qrCodes = await this.props.getAllQRCodes();
    this.setState({
      listQRCodes: qrCodes.map((item) => ({ value: item.code, label: `${item.code} - ${item.description}` })),
    });

    const allUsers = await this.props.getUserList();
    const usersByBranch = allUsers
      ? allUsers.filter((u) => u.mainBranch === selectBranch.value)
      : [];

    const listDefaultSeparators = usersByBranch.map((u) => ({
      value: u.login,
      label: `${u.login} - ${u.name}`,
    }));
    const listUsersRestriction = usersByBranch.map((u) => ({
      value: u.id,
      label: `${u.login} - ${u.name}`,
    }));

    this.setState({ listDefaultSeparators, listUsersRestriction });

    await this.loadGroupedOutboundCustomerOptions();
  };

  loadGroupedOutboundCustomerOptions = async () => {
    const customers = await this.props.getCustomersOptions();
    const listGroupedOutboundCustomers = (customers || []).map((customer) => {
      if (customer.value && customer.label) {
        return {
          value: customer.value,
          label: customer.label,
        };
      }

      return {
        value: customer.code,
        label: `${customer.code} - ${customer.name}`,
      };
    });

    this.setState({ listGroupedOutboundCustomers });
  };

  getColumnOrderSeparation = async () => {
    const { groupProductsOnSeparation } = this.state;
    let orderSelectedId = '';

    if (this.props.location.state && this.props.location.state.orderType) {
      const { orderType } = this.props.location.state;
      const orderSelected = await orderType;

      if (orderSelected) orderSelectedId = orderSelected.id;
    }

    const {
      columnOrderSeparation,
    } = await this.props.getGridOptions({ orderSelectedId, groupProductsOnSeparation });

    this.setState({
      optionsColumnOrderSeparation: columnOrderSeparation && columnOrderSeparation.options
        ? columnOrderSeparation.options
        : [],
      selectedColumnOrderSeparation: columnOrderSeparation && columnOrderSeparation.selected
        ? columnOrderSeparation.selected
        : [],
    });
  };

  getOrderTypeSelected = async () => {
    if (this.props.location.state.orderType) {
      const { orderType } = this.props.location.state;
      const orderSelected = await orderType;

      const savedQR = this.state.listQRCodes.find(
        (item) => item.value === orderSelected.qrCodeModelCode,
      );

      const savedDefaultSeparator = this.state.listDefaultSeparators.find(
        (item) => item.value === orderSelected.defaultSeparator,
      );

      const savedDefaultInboundDeposit = this.state.optionsInboundDeposits.find(
        (item) => item.value === orderSelected.defaultInboundDeposit,
      );

      const savedGroupedOutboundCustomer = this.state.listGroupedOutboundCustomers.find(
        (item) => item.value === orderSelected.groupedOutboundCustomerCode,
      );

      if (orderSelected) {
        const selectBranch = this.state.listBranch.find(
          (element) => element.value === orderSelected.branchCode,
        );
        const branchPickingByLoad = selectBranch && selectBranch.pickingByLoad;

        this.setState({
          typeOrderId: orderSelected.id,
          type: orderSelected.type,
          name: orderSelected.name,
          branchCode: orderSelected.branchCode,
          branchName: selectBranch ? selectBranch.label : '',
          branchPickingByLoad,
          customerReturn: orderSelected.customerReturn,
          requestWeightDimensions: orderSelected.requestWeightDimensions,
          mandatoryWeightDimensions: orderSelected.mandatoryWeightDimensions,
          preConference: orderSelected.preConference,
          receiveLeftover: orderSelected.receiveLeftover,
          partialInboundCheck: orderSelected.partialInboundCheck,
          inboundCheckPlate: orderSelected.inboundCheckPlate,
          automaticSeparationAfterCuttingCables: orderSelected.automaticSeparationAfterCuttingCables,
          blindConference: orderSelected.blindConference,
          consolidation: orderSelected.consolidation,
          dockControl: orderSelected.dockControl,
          validateDockRemoval: orderSelected.validateDockRemoval,
          restrictionPicking: orderSelected.restrictionPicking,
          automaticCheckAfterPicking: orderSelected.automaticCheckAfterPicking,
          automaticPrintAfterPicking: orderSelected.automaticPrintAfterPicking,
          usesIndustryProcess: orderSelected.usesIndustryProcess,
          productionSeparation: orderSelected.productionSeparation,
          awaitBilling: orderSelected.awaitBilling,
          automaticAllocation: orderSelected.automaticAllocation,
          usesRequestManual: orderSelected.usesRequestManual,
          urgentAutoAssignSeparator: orderSelected.urgentAutoAssignSeparator,
          automaticPickingConfirmation: orderSelected.automaticPickingConfirmation,
          prefix: orderSelected.prefix,
          documentSeparationUzSuggestion: orderSelected.documentSeparationUzSuggestion,
          fullAllocation: orderSelected.fullAllocation,
          separateProductIntegration: orderSelected.separateProductIntegration,
          itemLevelObservation: orderSelected.itemLevelObservation,
          orderLevelObservation: orderSelected.orderLevelObservation,
          automaticDistributeOrders: orderSelected.automaticDistributeOrders,
          singleScanReturnAddress: orderSelected.singleScanReturnAddress,
          requestDeliveryConfirmation: orderSelected.requestDeliveryConfirmation,
          preStorageStage: orderSelected.preStorageStage,
          separationStage: orderSelected.separationStage,
          simplifiedLoadPicking: branchPickingByLoad && orderSelected.simplifiedLoadPicking,
          loadConsolidation: branchPickingByLoad
            && orderSelected.simplifiedLoadPicking
            && orderSelected.loadConsolidation,
          groupedOutboundCustomerCode: orderSelected.groupedOutboundCustomerCode || '',
          groupedOutboundCustomerName: savedGroupedOutboundCustomer
            ? savedGroupedOutboundCustomer.label
            : orderSelected.groupedOutboundCustomerCode || '',
          disableGroupedOutboundCustomer: this.props.isDetail
            || !(branchPickingByLoad && orderSelected.simplifiedLoadPicking),
          inboundManualRequest: orderSelected.inboundManualRequest,
          groupProductsOnSeparation: orderSelected.groupProductsOnSeparation,
          printOutboundFractionalPackagingLabel: orderSelected.printOutboundFractionalPackagingLabel,
          printInboundFractionalPackagingLabel: orderSelected.printInboundFractionalPackagingLabel,
          printFractionalLabelAfterLotConference: orderSelected.printFractionalLabelAfterLotConference,
          hideQuantityOnLabelWithoutCuttingPlan: orderSelected.hideQuantityOnLabelWithoutCuttingPlan,
          automaticStorage: orderSelected.automaticStorage,
          printSalesOrderPdf: orderSelected.printSalesOrderPdf,
          manualConfirmPicking: orderSelected.manualConfirmPicking,
          usesQrCode: orderSelected.usesQrCode,
          qrCodeModelCode: orderSelected.qrCodeModelCode,
          qrCodeModelName: savedQR ? savedQR.label : '',
          automaticCableCuttingPlan: orderSelected.automaticCableCuttingPlan,
          defaultSeparatorCode: orderSelected.defaultSeparator,
          defaultSeparatorName: savedDefaultSeparator ? savedDefaultSeparator.label : '',
          manualWaybill: orderSelected.manualWaybill,
          defaultInboundDepositCode: orderSelected.defaultInboundDeposit,
          defaultInboundDepositName: savedDefaultInboundDeposit ? savedDefaultInboundDeposit.label : '',
          selectedUsersRestrictionInbound: orderSelected.selectedUsersRestrictionInbound,
          selectedUsersRestrictionOutbound: orderSelected.selectedUsersRestrictionOutbound,
          advanceBilling: orderSelected.advanceBilling,
          ...(branchPickingByLoad && orderSelected.simplifiedLoadPicking && {
            consolidation: false,
            dockControl: false,
            validateDockRemoval: false,
            manualConfirmPicking: false,
          }),
        });

        await this.getColumnOrderSeparation();
      }
    }
  };

  setMode = () => {
    let mode;
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';
    else mode = '';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableName: false,
        disableType: false,
        disableBranchCode: false,
        disableRequestProduct: false,
        disableCustomerReturn: false,
        disableMandatoryProduct: false,
        disablePreConference: false,
        disableReceiveLeftover: false,
        disablePartialInboundCheck: false,
        disableInboundCheckPlate: false,
        disableConsolidation: false,
        disableDockControl: false,
        disableValidateDockRemoval: false,
        disableGroupProductsOnSeparation: false,
        disablePrefix: false,
        disableDocumentSeparationUzSuggestion: false,
        disableBlindConference: false,
        disableAutomaticSeparationAfterCuttingCables: false,
        disableAutomaticCableCuttingPlan: false,
        disabledRestrictionPicking: false,
        disableAutomaticCheckAfterPicking: false,
        disableAutomaticPrintAfterPicking: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
        disabledUsesIndustryProcess: false,
        disableAutomaticPickingConfirmation: false,
        disabledProductionSeparation: false,
        disabledAwaitBilling: false,
        disabledAutomaticAllocation: false,
        disabledUsesRequestManual: false,
        disableUrgentAutoAssignSeparator: false,
        disableFullAllocation: false,
        disableSeparateProductIntegration: false,
        disableItemLevelObservation: false,
        disableOrderLevelObservation: false,
        disableAutomaticDistributeOrders: false,
        disablePreStorageStage: false,
        disableSeparationStage: false,
        disableSimplifiedLoadPicking: false,
        disableSingleScanReturnAddress: false,
        disableRequestDeliveryConfirmation: false,
        disableManualRequestInbound: false,
        disablePrintOutboundFractionalPackagingLabel: false,
        disablePrintInboundFractionalPackagingLabel: false,
        disableAutomaticStorage: false,
        disablePrintSalesOrderPdf: false,
        disableManualConfirmPicking: false,
        disableUsesQrCode: false,
        disableDefaultSeparator: false,
        disableManualWaybill: false,
        disableDefaultInboundDeposit: false,
        disableAdvanceBilling: false,
        disableGroupedOutboundCustomer: false,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableName: false,
        disableType: true,
        disableBranchCode: true,
        disableCustomerReturn: false,
        disableRequestProduct: false,
        disableMandatoryProduct: false,
        disablePrefix: false,
        disableDocumentSeparationUzSuggestion: false,
        disableGroupProductsOnSeparation: false,
        disablePreConference: false,
        disableReceiveLeftover: false,
        disablePartialInboundCheck: false,
        disableInboundCheckPlate: false,
        disableConsolidation: false,
        disableDockControl: false,
        disableValidateDockRemoval: false,
        disableBlindConference: false,
        disableAutomaticSeparationAfterCuttingCables: false,
        disableAutomaticCableCuttingPlan: false,
        disabledRestrictionPicking: false,
        disableAutomaticCheckAfterPicking: false,
        disableAutomaticPrintAfterPicking: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
        disabledUsesIndustryProcess: false,
        disabledProductionSeparation: false,
        disabledAwaitBilling: false,
        disabledAutomaticAllocation: false,
        disabledUsesRequestManual: false,
        disableUrgentAutoAssignSeparator: false,
        disableAutomaticPickingConfirmation: false,
        disableFullAllocation: false,
        disableSeparateProductIntegration: false,
        disableItemLevelObservation: false,
        disableOrderLevelObservation: false,
        disableAutomaticDistributeOrders: false,
        disableSingleScanReturnAddress: false,
        disablePreStorageStage: false,
        disableSeparationStage: false,
        disableSimplifiedLoadPicking: false,
        disableRequestDeliveryConfirmation: false,
        disableManualRequestInbound: false,
        disablePrintOutboundFractionalPackagingLabel: false,
        disablePrintInboundFractionalPackagingLabel: false,
        disableAutomaticStorage: false,
        disablePrintSalesOrderPdf: false,
        disableManualConfirmPicking: false,
        disableUsesQrCode: false,
        disableDefaultSeparator: false,
        disableManualWaybill: false,
        disableDefaultInboundDeposit: false,
        disableAdvanceBilling: false,
        disableGroupedOutboundCustomer: false,
      });
    }
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  setValue = async (attr, value) => {
    if (
      (attr === 'consolidation' || attr === 'dockControl')
      && this.state.simplifiedLoadPicking
    ) {
      return;
    }

    if (attr === 'loadConsolidation') {
      if (!this.state.simplifiedLoadPicking) {
        return;
      }

      this.setState({
        loadConsolidation: value,
      });
      return;
    }

    if (attr === 'simplifiedLoadPicking') {
      if (!this.state.branchPickingByLoad) {
        return;
      }

      this.setState({
        simplifiedLoadPicking: value,
        disableGroupedOutboundCustomer: !value,
        ...(value && {
          consolidation: false,
          dockControl: false,
          validateDockRemoval: false,
          manualConfirmPicking: false,
        }),
        ...(!value && {
          groupedOutboundCustomerCode: '',
          groupedOutboundCustomerName: '',
          loadConsolidation: false,
        }),
      });
      return;
    }

    this.setState({
      [`${attr}`]: value,
    });

    if (attr === 'automaticCheckAfterPicking') {
      this.setState({
        disableAutomaticPrintAfterPicking: !value,
        ...(!value && { automaticPrintAfterPicking: value }),
      });
    }

    if (attr === 'groupProductsOnSeparation') {
      await this.getColumnOrderSeparation();
    }

    if (attr === 'dockControl') {
      this.setState({
        disableValidateDockRemoval: !value,
        ...(!value && { validateDockRemoval: value }),
      });
    }

    if (attr === 'requestWeightDimensions') {
      this.setState({
        ...(!value && { mandatoryWeightDimensions: value }),
      });
    }

    if (attr === 'customerReturn') {
      this.setState({
        ...(!value && { singleScanReturnAddress: value }),
      });
    }

    if (attr === 'manualConfirmPicking') {
      this.setState({
        ...(value && { dockControl: value }),
        disableDockControl: value,
      });
    }

    if (attr === 'usesQrCode') {
      this.setState({
        ...(!value && {
          qrCodeModelCode: '',
          qrCodeModelName: '',
          printFractionalLabelAfterLotConference: false,
          hideQuantityOnLabelWithoutCuttingPlan: false,
        }),
      });
    }

    if (attr === 'printInboundFractionalPackagingLabel' && !value) {
      this.setState({
        printFractionalLabelAfterLotConference: false,
        hideQuantityOnLabelWithoutCuttingPlan: false,
      });
    }

    if (attr === 'printFractionalLabelAfterLotConference' && !value) {
      this.setState({
        hideQuantityOnLabelWithoutCuttingPlan: false,
      });
    }
  };

  setValueDrop = async (attr, value) => {
    if (attr === 'branch') {
      const pickingByLoad = value && value.pickingByLoad;

      this.setState({
        branchCode: value ? value.value : '',
        branchName: value ? value.label : '',
        branchPickingByLoad: pickingByLoad,
        ...(!pickingByLoad && {
          simplifiedLoadPicking: false,
          loadConsolidation: false,
          groupedOutboundCustomerCode: '',
          groupedOutboundCustomerName: '',
          disableGroupedOutboundCustomer: true,
        }),
        ...(pickingByLoad && { disableGroupedOutboundCustomer: !this.state.simplifiedLoadPicking }),
      });
      return;
    }

    await this.setState({
      [`${attr}Code`]: value ? value.value : '',
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  createTypeOrder = async () => {
    const {
      name, branchCode, usesIndustryProcess, type, productionSeparation, restrictionPicking,
      automaticCheckAfterPicking, automaticPrintAfterPicking, automaticSeparationAfterCuttingCables,
      blindConference, awaitBilling, consolidation, dockControl, validateDockRemoval,
      inboundCheckPlate, mandatoryWeightDimensions, groupProductsOnSeparation,
      partialInboundCheck, fullAllocation, preConference, receiveLeftover, requestWeightDimensions,
      usesCableCuttingPlan, usesRequestManual, prefix, selectedInboundDeposits, selectedAllocateBalanceDeposits,
      automaticAllocation, urgentAutoAssignSeparator, automaticPickingConfirmation, documentSeparationUzSuggestion,
      separateProductIntegration, preStorageStage, separationStage, simplifiedLoadPicking,
      loadConsolidation, groupedOutboundCustomerCode,
      selectedColumnOrderSeparation,
      singleScanReturnAddress, requestDeliveryConfirmation, customerReturn, inboundManualRequest,
      selectedInboundColumnOrderCheck, selectedInboundColumnOrderStorage, selectedOutboundColumnOrderCheck,
      printInboundFractionalPackagingLabel, printFractionalLabelAfterLotConference,
      hideQuantityOnLabelWithoutCuttingPlan, printOutboundFractionalPackagingLabel, automaticStorage,
      itemLevelObservation, orderLevelObservation, printSalesOrderPdf, manualConfirmPicking, usesQrCode,
      qrCodeModelCode, automaticCableCuttingPlan, defaultSeparatorCode,
      manualWaybill, automaticDistributeOrders, defaultInboundDepositCode,
      selectedUsersRestrictionInbound, selectedUsersRestrictionOutbound, advanceBilling,
    } = this.state;

    try {
      const newOrder = await this.props.createTypeOrderSubmit({
        branchCode,
        customerReturn,
        name,
        type,
        prefix,
        documentSeparationUzSuggestion,
        requestWeightDimensions,
        mandatoryWeightDimensions,
        preConference,
        receiveLeftover,
        partialInboundCheck,
        inboundCheckPlate,
        usesIndustryProcess,
        productionSeparation,
        awaitBilling,
        automaticAllocation,
        usesCableCuttingPlan,
        consolidation,
        dockControl,
        validateDockRemoval,
        blindConference,
        automaticSeparationAfterCuttingCables,
        automaticCheckAfterPicking,
        automaticPrintAfterPicking,
        restrictionPicking,
        usesRequestManual,
        urgentAutoAssignSeparator,
        automaticPickingConfirmation,
        inboundDeposits: selectedInboundDeposits.join('|'),
        allocateBalanceDeposits: selectedAllocateBalanceDeposits.join('|'),
        fullAllocation,
        separateProductIntegration: productionSeparation && separateProductIntegration,
        itemLevelObservation,
        orderLevelObservation,
        automaticDistributeOrders,
        preStorageStage,
        separationStage,
        simplifiedLoadPicking,
        loadConsolidation: simplifiedLoadPicking && loadConsolidation,
        groupedOutboundCustomerCode: simplifiedLoadPicking
          ? groupedOutboundCustomerCode
          : '',
        singleScanReturnAddress,
        requestDeliveryConfirmation,
        columnOrderSeparation: selectedColumnOrderSeparation.join('|'),
        inboundManualRequest,
        groupProductsOnSeparation,
        printOutboundFractionalPackagingLabel,
        printInboundFractionalPackagingLabel,
        printFractionalLabelAfterLotConference,
        hideQuantityOnLabelWithoutCuttingPlan,
        inboundColumnOrderCheck: selectedInboundColumnOrderCheck.join('|'),
        inboundColumnOrderStorage: selectedInboundColumnOrderStorage.join('|'),
        outboundColumnOrderCheck: selectedOutboundColumnOrderCheck.join('|'),
        automaticStorage,
        printSalesOrderPdf,
        manualConfirmPicking,
        usesQrCode,
        qrCodeModelCode,
        automaticCableCuttingPlan,
        defaultSeparator: defaultSeparatorCode,
        manualWaybill,
        defaultInboundDeposit: defaultInboundDepositCode,
        usersRestrictionInbound: selectedUsersRestrictionInbound,
        usersRestrictionOutbound: selectedUsersRestrictionOutbound,
        advanceBilling,
      });

      if (newOrder) {
        if (newOrder.success === false) {
          await addNotification(
            'danger',
            I18n.t('BEE2801' /* Novo Tipo de Documento */),
            I18n.t('BEE2805', { 0: type } /* Erro ao incluir o Tipo de Documento %{0} */),
            'top-right',
          );
        } else {
          await addNotification(
            'success',
            I18n.t('BEE2801' /* Novo Tipo de Documento */),
            I18n.t('BEE2804', { 0: type } /* Tipo de documento %{0} incluído com sucesso ! */),
            'top-right',
          );
          this.props.history.push(ROUTES.ORDERS_TYPE_LIST);
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;
        await addNotification(
          'danger',
          I18n.t('BEE2801' /* Novo Tipo de Documento */),
          `${error.code} - ${error.message || error.details}`,
          'top-right',
        );
      }
    }
  };

  updateTypeOrderSubmit = async () => {
    const {
      name, type, branchCode, typeOrderId, productionSeparation, restrictionPicking, awaitBilling,
      usesIndustryProcess, automaticCheckAfterPicking, automaticPrintAfterPicking,
      automaticSeparationAfterCuttingCables, usesRequestManual, blindConference, consolidation, dockControl,
      validateDockRemoval, groupProductsOnSeparation, automaticStorage,
      inboundCheckPlate, mandatoryWeightDimensions, automaticAllocation, partialInboundCheck, preConference,
      receiveLeftover, requestWeightDimensions, usesCableCuttingPlan, prefix,
      selectedInboundDeposits, selectedAllocateBalanceDeposits, urgentAutoAssignSeparator, automaticPickingConfirmation,
      fullAllocation, documentSeparationUzSuggestion, separateProductIntegration, preStorageStage,
      separationStage, simplifiedLoadPicking, loadConsolidation, groupedOutboundCustomerCode,
      singleScanReturnAddress, selectedColumnOrderSeparation,
      requestDeliveryConfirmation,
      customerReturn, inboundManualRequest, printOutboundFractionalPackagingLabel, selectedInboundColumnOrderCheck,
      selectedInboundColumnOrderStorage, selectedOutboundColumnOrderCheck,
      printInboundFractionalPackagingLabel, printFractionalLabelAfterLotConference,
      hideQuantityOnLabelWithoutCuttingPlan, itemLevelObservation, orderLevelObservation, printSalesOrderPdf,
      manualConfirmPicking, usesQrCode, qrCodeModelCode, automaticCableCuttingPlan, defaultSeparatorCode,
      manualWaybill, automaticDistributeOrders,
      defaultInboundDepositCode, selectedUsersRestrictionInbound, selectedUsersRestrictionOutbound, advanceBilling,
    } = this.state;

    try {
      await this.props.updateTypeOrder({
        id: typeOrderId,
        branchCode,
        customerReturn,
        name,
        type,
        prefix,
        requestWeightDimensions,
        documentSeparationUzSuggestion,
        mandatoryWeightDimensions,
        preConference,
        receiveLeftover,
        partialInboundCheck,
        inboundCheckPlate,
        usesIndustryProcess,
        productionSeparation,
        awaitBilling,
        automaticAllocation,
        usesCableCuttingPlan,
        consolidation,
        dockControl,
        validateDockRemoval,
        blindConference,
        automaticSeparationAfterCuttingCables,
        automaticCheckAfterPicking,
        automaticPrintAfterPicking,
        restrictionPicking,
        automaticPickingConfirmation,
        usesRequestManual,
        urgentAutoAssignSeparator,
        inboundDeposits: selectedInboundDeposits.join('|'),
        allocateBalanceDeposits: selectedAllocateBalanceDeposits.join('|'),
        fullAllocation,
        separateProductIntegration: productionSeparation && separateProductIntegration,
        itemLevelObservation,
        orderLevelObservation,
        automaticDistributeOrders,
        preStorageStage,
        separationStage,
        simplifiedLoadPicking,
        loadConsolidation: simplifiedLoadPicking && loadConsolidation,
        groupedOutboundCustomerCode: simplifiedLoadPicking
          ? groupedOutboundCustomerCode
          : '',
        singleScanReturnAddress,
        requestDeliveryConfirmation,
        columnOrderSeparation: selectedColumnOrderSeparation.join('|'),
        inboundManualRequest,
        groupProductsOnSeparation,
        printOutboundFractionalPackagingLabel,
        printInboundFractionalPackagingLabel,
        printFractionalLabelAfterLotConference,
        hideQuantityOnLabelWithoutCuttingPlan,
        inboundColumnOrderCheck: selectedInboundColumnOrderCheck.join('|'),
        inboundColumnOrderStorage: selectedInboundColumnOrderStorage.join('|'),
        outboundColumnOrderCheck: selectedOutboundColumnOrderCheck.join('|'),
        automaticStorage,
        printSalesOrderPdf,
        manualConfirmPicking,
        usesQrCode,
        qrCodeModelCode,
        automaticCableCuttingPlan,
        defaultSeparator: defaultSeparatorCode,
        manualWaybill,
        defaultInboundDeposit: defaultInboundDepositCode,
        usersRestrictionInbound: selectedUsersRestrictionInbound,
        usersRestrictionOutbound: selectedUsersRestrictionOutbound,
        advanceBilling,
      });
      await addNotification(
        'success',
        I18n.t('BEE2802' /* Editar Tipo de Documento */),
        I18n.t('BEE2806', { 0: type } /* Tipo de documento %{0} atualizado com sucesso ! */),
        'top-right',
      );
      this.props.history.push(ROUTES.ORDERS_TYPE_LIST);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;
        await addNotification(
          'danger',
          I18n.t('BEE2802' /* Editar Tipo de Documento */),
          `${error.code} - ${error.message || error.details}`,
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      type, name, mode, showCancel, showCreate, showUpdate, listBranch, listQRCodes,
      qrCodeModelCode, qrCodeModelName, automaticCableCuttingPlan, awaitBilling, automaticAllocation,
      branchCode, branchName, branchPickingByLoad, usesIndustryProcess, productionSeparation,
      usesRequestManual,
      urgentAutoAssignSeparator, automaticPickingConfirmation, fullAllocation, separateProductIntegration,
      singleScanReturnAddress, requestDeliveryConfirmation, groupProductsOnSeparation,
      printOutboundFractionalPackagingLabel, printInboundFractionalPackagingLabel,
      printFractionalLabelAfterLotConference, hideQuantityOnLabelWithoutCuttingPlan,
      itemLevelObservation, orderLevelObservation, printSalesOrderPdf, manualConfirmPicking, usesQrCode,
      defaultSeparatorCode, defaultSeparatorName, listDefaultSeparators,
      manualWaybill, automaticDistributeOrders, advanceBilling,
    } = this.state;

    const {
      requestWeightDimensions, mandatoryWeightDimensions, partialInboundCheck,
      inboundCheckPlate, preConference, automaticStorage,
      disableRequestProduct, disableMandatoryProduct, disablePartialInboundCheck,
      disableInboundCheckPlate, disablePreConference, disableAutomaticStorage,
      receiveLeftover, disableReceiveLeftover, preStorageStage, separationStage, simplifiedLoadPicking,
      loadConsolidation,
      customerReturn, inboundManualRequest,
    } = this.state;

    const {
      usesCableCuttingPlan, consolidation, dockControl, validateDockRemoval, blindConference,
      restrictionPicking, disabledAwaitBilling,
      automaticSeparationAfterCuttingCables, automaticCheckAfterPicking, prefix,
      disabledAutomaticAllocation, documentSeparationUzSuggestion, automaticPrintAfterPicking,
    } = this.state;

    const {
      disableConsolidation, disableDockControl, disableValidateDockRemoval, disableBlindConference,
      disableBranchCode, disabledRestrictionPicking, disableAutomaticSeparationAfterCuttingCables,
      disableAutomaticCheckAfterPicking, disableName,
      disabledUsesIndustryProcess, disableType, disabledProductionSeparation, disableFullAllocation,
      disabledUsesRequestManual, disablePrefix, disableUrgentAutoAssignSeparator, disableAutomaticPickingConfirmation,
      disableDocumentSeparationUzSuggestion, disableSeparateProductIntegration, disableAutomaticPrintAfterPicking,
      disablePreStorageStage, disableSeparationStage, disableSimplifiedLoadPicking,
      groupedOutboundCustomerCode, groupedOutboundCustomerName,
      listGroupedOutboundCustomers, disableGroupedOutboundCustomer,
      disableSingleScanReturnAddress,
      disableRequestDeliveryConfirmation, disableCustomerReturn, disableManualRequestInbound,
      disableGroupProductsOnSeparation, disablePrintOutboundFractionalPackagingLabel,
      disablePrintInboundFractionalPackagingLabel, disableItemLevelObservation, disableOrderLevelObservation,
      disablePrintSalesOrderPdf, disableManualConfirmPicking, disableUsesQrCode, disableAutomaticCableCuttingPlan,
      disableDefaultSeparator, disableManualWaybill, disableAutomaticDistributeOrders, disableAdvanceBilling,
    } = this.state;

    const {
      optionsInboundDeposits, selectedInboundDeposits,
      defaultInboundDepositCode, defaultInboundDepositName, disableDefaultInboundDeposit,
    } = this.state;

    const listSelectedInboundDeposits = optionsInboundDeposits
      ? optionsInboundDeposits.filter((deposit) => selectedInboundDeposits.includes(deposit.value))
      : [];

    let title = '';
    let breadActive = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE2801' /* Novo Tipo de Documento */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE2802' /* Editar Tipo de Documento */);
      breadActive = `${type} - ${name}`;
    } else if (mode === 'detail') {
      title = I18n.t('BEE2803' /* Detalhes do Tipo de Documento */);
      breadActive = `${type} - ${name}`;
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE2796' /* Tipos de Documentos */)}</li>
            <li className="breadcrumb-item active">{breadActive || title}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <Panel className="panel-with-tabs">
              <PanelHeader noButton />
              <PanelBody>
                <Nav tabs justified fill style={{ backgroundColor: 'lightgray' }}>
                  <NavItem>
                    <NavLink
                      className={this.state.activeTab === '1' ? 'active' : ''}
                      onClick={() => {
                        this.toggleTab('1');
                      }}
                    >
                      <span className="d-sm-none">Tab 1</span>
                      <span className="d-sm-block d-none">{I18n.t('BEE370' /* Dados */)}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={this.state.activeTab === '2' ? 'active' : ''}
                      onClick={() => {
                        this.toggleTab('2');
                      }}
                    >
                      <span className="d-sm-none">Tab 2</span>
                      <span className="d-sm-block d-none">{I18n.t('BEE36' /* Recebimento */)}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={this.state.activeTab === '3' ? 'active' : ''}
                      onClick={() => {
                        this.toggleTab('3');
                      }}
                    >
                      <span className="d-sm-none">Tab 3</span>
                      <span className="d-sm-block d-none">{I18n.t('BEE41' /* Expedição */)}</span>
                    </NavLink>
                  </NavItem>

                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <div className="ml-3">
                      <Form
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createSelectDropDown(
                            { value: branchCode, label: branchName },
                            'branch',
                            `${I18n.t('BEE145' /* Filial */)}:`,
                            listBranch,
                            disableBranchCode,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true,
                          ),
                          formContext.createInput(
                            type,
                            'type',
                            `${I18n.t('BEE82' /* Código */)}:`,
                            I18n.t('BEE2807' /* Informe o tipo do documento */),
                            'text',
                            true,
                            disableType,
                          ),
                          formContext.createInput(
                            name,
                            'name',
                            `${I18n.t('BEE1897' /* Descrição */)}:`,
                            I18n.t('BEE2808' /* Informe a descrição do tipo do documento */),
                            'text',
                            true,
                            disableName,
                          ),
                          formContext.createCheckBoxLabel(
                            usesIndustryProcess,
                            'usesIndustryProcess',
                            I18n.t('BEE2809' /* Utiliza processo de Indústria */),
                            disabledUsesIndustryProcess,
                          ),
                          formContext.createCheckBoxLabel(
                            usesRequestManual,
                            'usesRequestManual',
                            I18n.t('BEE2974' /* Utiliza processo de Requisição Manual */),
                            disabledUsesRequestManual,
                          ),
                          formContext.createCheckBoxLabel(
                            usesQrCode,
                            'usesQrCode',
                            I18n.t('BEE4612' /* Utiliza configuração de QR Code */),
                            disableUsesQrCode,
                          ),
                          formContext.createSelectDropDown(
                            { value: qrCodeModelCode, label: qrCodeModelName },
                            'qrCodeModel',
                            `${I18n.t('BEE4614' /* Modelo de QR Code */)}:`,
                            listQRCodes,
                            disableUsesQrCode || !usesQrCode,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            false,
                          ),
                        ])}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div>
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE191' /* Geral */)}
                        </h1>
                      </div>
                      <Form // GERAL
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createInputPrefix(
                            prefix,
                            'prefix',
                            I18n.t('BEE2990' /* Prefixo do código: */),
                            I18n.t('BEE2991' /* Informe o prefixo */),
                            'text',
                            undefined,
                            disablePrefix,
                            undefined,
                            1.1,
                            undefined,
                            null,
                            524288,
                          ),
                          formContext.createCheckBoxLabel(
                            inboundManualRequest,
                            'inboundManualRequest',
                            I18n.t('BEE3771' /* Documento de Entrada Manual */),
                            disableManualRequestInbound,
                          ),
                          formContext.createCheckBoxLabel(
                            printInboundFractionalPackagingLabel,
                            'printInboundFractionalPackagingLabel',
                            I18n.t('BEE4194' /* Imprimir Etiqueta de Embalagem Fracionada */),
                            disablePrintInboundFractionalPackagingLabel,
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            printFractionalLabelAfterLotConference,
                            'printFractionalLabelAfterLotConference',
                            I18n.t('BEE4843' /* Impressão de Etiqueta Após Conferência de Lotes */),
                            disablePrintInboundFractionalPackagingLabel
                            || !usesQrCode
                            || !printInboundFractionalPackagingLabel,
                            {
                              id: 'printFractionalLabelAfterLotConferenceId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t(
                                'BEE4844',
                                // eslint-disable-next-line max-len
                                /* Configuração de QR Code e Impressão de Etiqueta de Embalagem Fracionada precisam estar habilitadas. */
                              ),
                            },
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            hideQuantityOnLabelWithoutCuttingPlan,
                            'hideQuantityOnLabelWithoutCuttingPlan',
                            I18n.t('BEE4845' /* Quantidade Oculta na Etiqueta sem Plano de Corte */),
                            disablePrintInboundFractionalPackagingLabel
                            || !printFractionalLabelAfterLotConference,
                            {
                              id: 'hideQuantityOnLabelWithoutCuttingPlanId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t(
                                'BEE4849',
                                // eslint-disable-next-line max-len
                                /* Disponível somente quando Impressão de Etiqueta Após Conferência de Lotes estiver habilitada. */
                              ),
                            },
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE37' /* Conferência */)}
                        </h1>
                      </div>
                      <Form // CONFERENCIA
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            inboundCheckPlate,
                            'inboundCheckPlate',
                            I18n.t('BEE399' /* Conferência de Placa */),
                            disableInboundCheckPlate,
                          ),
                          formContext.createCheckBoxLabel(
                            preConference,
                            'preConference',
                            I18n.t('BEE1792' /* Pré-conferência */),
                            disablePreConference,
                          ),
                          formContext.createCheckBoxLabel(
                            partialInboundCheck,
                            'partialInboundCheck',
                            I18n.t('BEE783' /* Conferência física parcial */),
                            disablePartialInboundCheck,
                          ),
                          formContext.createCheckBoxLabel(
                            receiveLeftover,
                            'receiveLeftover',
                            I18n.t('BEE1967' /* Permite receber Sobra de Produto */),
                            disableReceiveLeftover,
                          ),
                          formContext.createCheckBoxLabel(
                            requestWeightDimensions,
                            'requestWeightDimensions',
                            I18n.t('BEE784' /* Solicitar pesos e dimensões do produto na conferência Física */),
                            disableRequestProduct,
                          ),
                          formContext.createCheckBoxLabel(
                            mandatoryWeightDimensions,
                            'mandatoryWeightDimensions',
                            I18n.t('BEE786' /* Pesagem e medição obrigatórios */),
                            disableMandatoryProduct || !requestWeightDimensions,
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE38' /* Armazenamento */)}
                        </h1>
                      </div>
                      <Form // ARMAZENAMENTO
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            preStorageStage,
                            'preStorageStage',
                            I18n.t('BEE3496' /* Utiliza o Stage de Pré-Armazenagem */),
                            disablePreStorageStage,
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            automaticStorage,
                            'automaticStorage',
                            I18n.t('BEE4341' /* Armazenamento Automático */),
                            disableAutomaticStorage,
                            {
                              id: 'automaticStorageId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t('BEE4346'),
                              // eslint-disable-next-line max-len
                              /* O Armazenamento Automático utilizará o primeiro depósito selecionado em Depósitos para Armazenagem. */
                            },
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE39' /* Devolução */)}
                        </h1>
                      </div>
                      <Form // DEVOLUCAO
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            customerReturn,
                            'customerReturn',
                            I18n.t('BEE3769' /* Devolução do Cliente */),
                            disableCustomerReturn,
                          ),
                          formContext.createCheckBoxLabel(
                            singleScanReturnAddress,
                            'singleScanReturnAddress',
                            I18n.t('BEE3660' /* Leitura única do endereço na devolução */),
                            disableSingleScanReturnAddress || !customerReturn,
                          ),
                        ])}
                      />
                    </div>
                    <hr />
                    <DualList
                      id="dualselectinbounddeposit"
                      title={I18n.t('BEE4066' /* Depósitos para Armazenagem */)}
                      availableHeader={I18n.t('BEE2993' /* Depósitos Disponíveis */)}
                      selectedHeader={I18n.t('BEE2994' /* Depósitos Selecionados */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsInboundDeposits}
                      selected={this.state.selectedInboundDeposits}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedInboundDeposits'); }}
                      disabled={(mode === 'detail')}
                    />
                    <div className="mt-4">
                      <Form
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createSelectDropDown(
                            { value: defaultInboundDepositCode, label: defaultInboundDepositName },
                            'defaultInboundDeposit',
                            I18n.t('BEE4794' /* Depósito Padrão */),
                            listSelectedInboundDeposits,
                            disableDefaultInboundDeposit,
                          ),
                        ])}
                      />
                    </div>
                    <DualList
                      id="dualSelectInboundColumnsOrder"
                      title={I18n.t('BEE4331' /* Ordenar colunas na conferência do coletor */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsInboundColumnOrderCheck}
                      selected={this.state.selectedInboundColumnOrderCheck}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedInboundColumnOrderCheck'); }}
                      disabled={(mode === 'detail')}
                    />
                    <DualList
                      id="dualSelectInboundColumnOrderStorage"
                      title={I18n.t('BEE4340' /* Ordenar colunas no armazenamento do coletor */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsInboundColumnOrderStorage}
                      selected={this.state.selectedInboundColumnOrderStorage}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedInboundColumnOrderStorage'); }}
                      disabled={(mode === 'detail')}
                    />
                    <hr />
                    <DualList
                      id="restrictionUsersInbound"
                      title={I18n.t('BEE4798' /* Usuários com Restrição de Recebimento */)}
                      availableHeader={I18n.t('BEE4799' /* Usuários Disponíveis */)}
                      selectedHeader={I18n.t('BEE4800' /* Usuários Selecionados */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.listUsersRestriction}
                      selected={this.state.selectedUsersRestrictionInbound}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedUsersRestrictionInbound'); }}
                      disabled={(mode === 'detail')}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <div>
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE191' /* Geral */)}
                        </h1>
                      </div>
                      <Form // Geral
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            consolidation,
                            'consolidation',
                            I18n.t('BEE1046' /* Consolidação */),
                            disableConsolidation || simplifiedLoadPicking,
                          ),
                          formContext.createCheckBoxLabel(
                            awaitBilling,
                            'awaitBilling',
                            I18n.t('BEE2962' /* Aguardar Faturamento */),
                            disabledAwaitBilling,
                          ),
                          formContext.createCheckBoxLabel(
                            requestDeliveryConfirmation,
                            'requestDeliveryConfirmation',
                            I18n.t('BEE3682' /* Solicitação de Confirmação de Entrega */),
                            disableRequestDeliveryConfirmation,
                          ),
                          formContext.createCheckBoxLabel(
                            printOutboundFractionalPackagingLabel,
                            'printOutboundFractionalPackagingLabel',
                            I18n.t('BEE4194' /* Imprimir Etiqueta de Embalagem Fracionada */),
                            disablePrintOutboundFractionalPackagingLabel,
                          ),
                          formContext.createCheckBoxLabel(
                            printSalesOrderPdf,
                            'printSalesOrderPdf',
                            I18n.t('BEE4549' /* Permitir a geração de PDF do Pedido de Venda */),
                            disablePrintSalesOrderPdf,
                          ),
                          formContext.createCheckBoxLabel(
                            manualConfirmPicking,
                            'manualConfirmPicking',
                            I18n.t('BEE4560' /* Integração Confirmação de Separação Manual */),
                            disableManualConfirmPicking || simplifiedLoadPicking,
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            manualWaybill,
                            'manualWaybill',
                            I18n.t('BEE4651' /* Gera Romaneio Manual */),
                            disableManualWaybill || dockControl,
                            {
                              id: 'manualWaybillId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t('BEE4661'),
                              // eslint-disable-next-line max-len
                              /* Quando ativo, desabilita o controle de doca. Quando o controle de doca estiver ativo, este parâmetro ficará desabilitado. */
                            },
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            advanceBilling,
                            'advanceBilling',
                            I18n.t('BEE4846' /* Faturamento Antecipado */),
                            disableAdvanceBilling,
                            {
                              id: 'advanceBillingId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t('BEE4847'),
                              // eslint-disable-next-line max-len
                              /* Documentos com Faturamento Antecipado ficam bloqueados para cancelamento, divergências, quantidade menor que a solicitada e devolução de picking. */
                            },
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE2009' /* Alocação */)}
                        </h1>
                      </div>
                      <Form // Alocação
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            automaticAllocation,
                            'automaticAllocation',
                            I18n.t('BEE3003' /* Aloca Saldo Automaticamente */),
                            disabledAutomaticAllocation,
                          ),
                          formContext.createCheckBoxLabel(
                            fullAllocation,
                            'fullAllocation',
                            I18n.t('BEE3315' /* Alocação Total do Pedido */),
                            disableFullAllocation,
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE43' /* Separação */)}
                        </h1>
                      </div>
                      <Form // Separação
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            simplifiedLoadPicking,
                            'simplifiedLoadPicking',
                            I18n.t('BEE4861' /* Separação por Carga Simplificada */),
                            disableSimplifiedLoadPicking || !branchPickingByLoad,
                          ),
                          formContext.createCheckBoxLabel(
                            loadConsolidation,
                            'loadConsolidation',
                            I18n.t('BEE4882' /* Consolidação por Carga */),
                            disableSimplifiedLoadPicking
                            || !branchPickingByLoad
                            || !simplifiedLoadPicking,
                          ),
                          ...(simplifiedLoadPicking ? [
                            formContext.createSelectDropDown(
                              {
                                value: groupedOutboundCustomerCode,
                                label: groupedOutboundCustomerName,
                              },
                              'groupedOutboundCustomer',
                              I18n.t('BEE4871' /* Cliente padrão para documentos agrupados */),
                              listGroupedOutboundCustomers,
                              disableGroupedOutboundCustomer || mode === 'detail',
                            ),
                          ] : []),
                          formContext.createCheckBoxLabel(
                            automaticPickingConfirmation,
                            'automaticPickingConfirmation',
                            I18n.t('BEE3277' /* Confirmação automática da separação */),
                            disableAutomaticPickingConfirmation,
                          ),
                          formContext.createCheckBoxLabel(
                            documentSeparationUzSuggestion,
                            'documentSeparationUzSuggestion',
                            I18n.t('BEE3320' /* Última UZ utilizada na Separação. */),
                            disableDocumentSeparationUzSuggestion,
                          ),
                          formContext.createCheckBoxLabel(
                            urgentAutoAssignSeparator,
                            'urgentAutoAssignSeparator',
                            I18n.t('BEE3273' /* Urgência automática ao atribuir separador */),
                            disableUrgentAutoAssignSeparator,
                          ),
                          formContext.createCheckBoxLabel(
                            restrictionPicking,
                            'restrictionPicking',
                            I18n.t('BEE2778' /* Utilizar Monitor de Restrição de Separação */),
                            disabledRestrictionPicking,
                          ),
                          formContext.createCheckBoxLabel(
                            separationStage,
                            'separationStage',
                            I18n.t('BEE3590' /* Utiliza o Stage de Separação */),
                            disableSeparationStage,
                          ),
                          formContext.createCheckBoxWithCustomTooltip(
                            groupProductsOnSeparation,
                            'groupProductsOnSeparation',
                            I18n.t('BEE4036' /* Utiliza Agrupamento de Produtos na Separação */),
                            disableGroupProductsOnSeparation,
                            {
                              id: 'groupProductsOnSeparationId',
                              type: 'info',
                              style: {
                                color: 'blue', position: 'absolute', top: 3, paddingLeft: 5,
                              },
                              place: 'top',
                              content: I18n.t('BEE4041')
                              // eslint-disable-next-line max-len
                              /* Esta funcionalidade considera o vínculo do cadastro "Agrupamento de Produto" com o "Produto", para ordenar os itens na tela de separação do coletor de acordo com sua Sequência de Agrupamento. */,
                            },
                          ),
                          formContext.createCheckBoxLabel(
                            productionSeparation,
                            'productionSeparation',
                            I18n.t('BEE2890' /* Separação de Ordem de Produção */),
                            disabledProductionSeparation,
                          ),
                          formContext.createCheckBoxLabel(
                            separateProductIntegration && productionSeparation,
                            'separateProductIntegration',
                            I18n.t('BEE3329' /* Envie integração para cada produto separado na ordem de produção */),
                            disableSeparateProductIntegration || !productionSeparation,
                          ),
                          formContext.createCheckBoxLabel(
                            itemLevelObservation,
                            'itemLevelObservation',
                            I18n.t('BEE4476' /* Gravar Observação a nível de Itens. */),
                            disableItemLevelObservation,
                          ),
                          formContext.createCheckBoxLabel(
                            orderLevelObservation,
                            'orderLevelObservation',
                            I18n.t('BEE4477' /* Gravar observação a nível de documento. */),
                            disableOrderLevelObservation,
                          ),
                          formContext.createCheckBoxLabel(
                            automaticDistributeOrders,
                            'automaticDistributeOrders',
                            I18n.t('BEE4664' /* Permite distribuição automática dos pedidos. */),
                            disableAutomaticDistributeOrders,
                          ),
                          formContext.createSelectDropDown(
                            { value: defaultSeparatorCode, label: defaultSeparatorName },
                            'defaultSeparator',
                            I18n.t('BEE4643' /* Separador Padrão */),
                            listDefaultSeparators,
                            disableDefaultSeparator,
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE757' /* Conferência de Volume */)}
                        </h1>
                      </div>
                      <Form // Conferência Volume
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            automaticCheckAfterPicking,
                            'automaticCheckAfterPicking',
                            I18n.t('BEE2354' /* Conferência Automática Após Separação Por Documento */),
                            disableAutomaticCheckAfterPicking,
                          ),
                          formContext.createCheckBoxLabel(
                            automaticPrintAfterPicking,
                            'automaticPrintAfterPicking',
                            I18n.t('BEE3515' /* Impressão automática da etiqueta de volume na separação. */),
                            disableAutomaticPrintAfterPicking || !automaticCheckAfterPicking,
                          ),
                          formContext.createCheckBoxLabel(
                            blindConference,
                            'blindConference',
                            I18n.t('BEE1053' /* Conferência a Cegas */),
                            disableBlindConference,
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE19' /* Docas */)}
                        </h1>
                      </div>
                      <Form // Docas
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            dockControl,
                            'dockControl',
                            I18n.t('BEE1049' /* Controla Doca */),
                            disableDockControl || manualWaybill || simplifiedLoadPicking,
                          ),
                          formContext.createCheckBoxLabel(
                            validateDockRemoval,
                            'validateDockRemoval',
                            I18n.t('BEE3762' /* Validar Remoção de Volumes da Doca Via Coletor */),
                            disableValidateDockRemoval || !dockControl,
                          ),
                        ])}
                      />
                      <hr />
                      <div className="d-flex align-items-center mb-md-3 mb-1">
                        <h1 className="page-header mb-0">
                          {I18n.t('BEE1420' /* Corte de Cabos */)}
                        </h1>
                      </div>
                      <Form // Corte de Cabos
                        noPanel
                        setValue={this.setValue}
                        setValueDrop={this.setValueDrop}
                        inputs={(formContext) => ([
                          formContext.createCheckBoxLabel(
                            automaticSeparationAfterCuttingCables,
                            'automaticSeparationAfterCuttingCables',
                            I18n.t('BEE1054' /* Separação Automática Após Corte de Cabos */),
                            disableAutomaticSeparationAfterCuttingCables || !usesCableCuttingPlan,
                          ),
                          formContext.createCheckBoxLabel(
                            automaticCableCuttingPlan,
                            'automaticCableCuttingPlan',
                            I18n.t('BEE4626' /* Criação Automática de Plano de Corte */),
                            disableAutomaticCableCuttingPlan || !usesCableCuttingPlan,
                          ),
                        ])}
                      />
                    </div>
                    <hr />
                    <DualList
                      id="dualselectdeposit"
                      title={I18n.t('BEE2992' /* Depósitos para alocação de saldo */)}
                      availableHeader={I18n.t('BEE2993' /* Depósitos Disponíveis */)}
                      selectedHeader={I18n.t('BEE2994' /* Depósitos Selecionados */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsAllocateBalanceDeposits}
                      selected={this.state.selectedAllocateBalanceDeposits}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedAllocateBalanceDeposits'); }}
                      disabled={(mode === 'detail')}
                    />
                    <DualList
                      id="dualselectdeposit"
                      title={I18n.t('BEE3634' /* Ordenar colunas na separação do coletor */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsColumnOrderSeparation}
                      selected={this.state.selectedColumnOrderSeparation}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedColumnOrderSeparation'); }}
                      disabled={(mode === 'detail')}
                    />
                    <DualList
                      id="dualSelectOutboundCheckColumnsOrder"
                      title={I18n.t('BEE4331' /* Ordenar colunas na conferência do coletor */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.optionsOutboundColumnOrderCheck}
                      selected={this.state.selectedOutboundColumnOrderCheck}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedOutboundColumnOrderCheck'); }}
                      disabled={(mode === 'detail')}
                    />
                    <hr />
                    <DualList
                      id="restrictionUsersOutbound"
                      title={I18n.t('BEE4801' /* Usuários com Restrição de Expedição */)}
                      availableHeader={I18n.t('BEE4799' /* Usuários Disponíveis */)}
                      selectedHeader={I18n.t('BEE4800' /* Usuários Selecionados */)}
                      filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                      options={this.state.listUsersRestriction}
                      selected={this.state.selectedUsersRestrictionOutbound}
                      onChange={(item) => { this.onChangeDualList(item, 'selectedUsersRestrictionOutbound'); }}
                      disabled={(mode === 'detail')}
                    />
                  </TabPane>
                </TabContent>
              </PanelBody>
              <PanelFooter>
                <Link to={{ pathname: ROUTES.ORDERS_TYPE_LIST, state: { dice: this.props.location.dice } }}>
                  {(showCancel
                    ? (
                      <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    )
                    : (
                      <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                        {I18n.t('BEE137' /* Voltar */)}
                      </OneClickButton>
                    ))}
                </Link>
                {(showCreate
                  && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createTypeOrder()}
                    >
                      {I18n.t('BEE138' /* Criar */)}

                    </OneClickButton>
                  )
                )}
                {(showUpdate
                  && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateTypeOrderSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}

                    </OneClickButton>
                  )
                )}
              </PanelFooter>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getUserList: () => dispatch(getUserList()),
  getCustomersOptions: () => dispatch(getCustomersOptions()),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getGridOptions: (typeOrder = '') => dispatch(getGridOptions(typeOrder)),
  getAllQRCodes: () => dispatch(getAllQRCodes()),
  createTypeOrderSubmit: (newTypeOrder) => dispatch(createTypeOrder(newTypeOrder)),
  updateTypeOrder: (updateTypeOrder) => dispatch(updateTypeOrders(updateTypeOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TypeOrdersForm));
